/**
 * @packageDocumentation
 * @module      NewPasswordQualifier.ts
 * @description Tells whether a proposed new password is valid.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
export default class NewPasswordQualifier {
    /**
     * Returns true if the new password is OK; false if not.
     * Also returns true if the new password is missing or empty because we'd want a "mandatory" attribute
     * on an sh-input to take priority.
     *
     * @param newPassword The proposed new password
     * @param username The username (optional). If included, the new password must not contain the username.
     * @param oldPassword The old password (optional). If included, we will ensure that the new password
     * does not equal the old one.
     */
    static qualifies(newPassword, username, oldPassword) {
        if (!newPassword) {
            return true;
        }
        return newPassword.length >= 8 &&
            newPassword.match(/[A-Za-z]/) !== null &&
            newPassword.match(/\d/) !== null &&
            newPassword.match(/[^A-Za-z0-9]/) !== null &&
            (!username || !newPassword.includes(username)) &&
            (!oldPassword || newPassword !== oldPassword);
    }
}
//# sourceMappingURL=NewPasswordQualifier.js.map